import { Alert } from '@/global/components/Alert'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import {
    TabCompetencia,
    useAberturaFechamentoCompetenciaOutletContext,
} from 'pages/FechamentoCompetencia'
import { IFechamento, alteracaoCompetencia, empresas } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

export default function AbrirFecharCompetencia() {
    const empresa = useStore(state => state.company)
    const { tab } = useAberturaFechamentoCompetenciaOutletContext()
    const { mutateAsync: abrir, isLoading: abrindo } =
        alteracaoCompetencia.abertura.mutations.useCreate({
            invalidateQuery: true,
        })
    const { mutateAsync: fechar, isLoading: fechando } =
        alteracaoCompetencia.fechamento.mutations.useCreate({
            invalidateQuery: true,
        })
    const { data: proximoFechamento } =
        alteracaoCompetencia.proximoFechamento.useFetch<IFechamento>({
            queryParams: { empresaId: empresa?.id },
            enabled: !!empresa,
        })
    const competencia = dayjs(empresa?.competenciaAtual).format('MM/YYYY')
    const competenciaAnterior = dayjs(empresa?.competenciaAtual)
        .subtract(1, 'month')
        .format('MM/YYYY')

    if (!empresa) return null

    const handleSubmit = async () => {
        if (tab === TabCompetencia.ABERTURA) {
            return abrir(
                {
                    competencia,
                    empresaId: empresa.id,
                    justificativa: 'abertura',
                } as any,
                {
                    onSuccess: () => {
                        toast.success('Competência aberta com sucesso')
                        empresas.invalidateQueries()
                        alteracaoCompetencia.proximoFechamento.invalidateQueries()
                    },
                    onError: err => {
                        toast.error(err.message)
                    },
                },
            )
        } else {
            return fechar(
                {
                    competencia,
                    empresaId: empresa.id,
                    justificativa: 'fechamento',
                } as any,
                {
                    onSuccess: () => {
                        toast.success('Competência fechada com sucesso')
                        empresas.invalidateQueries()
                        alteracaoCompetencia.proximoFechamento.invalidateQueries()
                    },
                    onError: err => {
                        toast.error(err.message)
                    },
                },
            )
        }
    }

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            loading={abrindo || fechando}
            width="auto"
            height="auto"
            open={hasPermission(['create', 'FechamentoDeCompetência'])}
        >
            <Dialog.Title>
                {tab === TabCompetencia.ABERTURA
                    ? `Reabrir competência`
                    : `Fechar competência`}
            </Dialog.Title>
            <Dialog.Content>
                {(() => {
                    if (tab === TabCompetencia.ABERTURA) {
                        return `Deseja realizar a abertura da competência ${competenciaAnterior}?`
                    } else if (proximoFechamento?.isNear) {
                        return (
                            <Alert severity="warning">
                                <p>
                                    Tem certeza que deseja fechar a competência?
                                </p>
                                <br />
                                <p>
                                    Esse é o mês de encerramento do período
                                    atual do banco de horas.
                                </p>
                                <p>
                                    Não se esqueça de fazer os ajustes
                                    necessários antes de fechar a competência.
                                </p>
                            </Alert>
                        )
                    } else {
                        return `Deseja realizar o fechamento da competência ${competencia}?`
                    }
                })()}
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton
                    closeOnSubmit
                    {...(proximoFechamento?.isNear && { color: 'error' })}
                >
                    Confirmar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
